import { SECTION } from "constants/SettingsConstants";
import { useEffect } from "react";
import { useDispatch } from "utils/redux";
import { setCurrentSection } from "reducers/main";
import { setService } from "reducers/future-medical";
import type { DocumentManagementDataType } from "types/DataTypes";

import "./DocumentManagementPageContainer.scss";

type DocumentManagementContainerPropTypes = {
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  layout?: "full" | "split";
  documentManagementFile?: DocumentManagementDataType;
};

const DocumentManagementPageContainer = ({
  header,
  footer,
  children,
  layout = "split",
  documentManagementFile,
}: DocumentManagementContainerPropTypes) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setService(documentManagementFile));
  }, [dispatch, documentManagementFile]);

  useEffect(() => {
    dispatch(setCurrentSection(SECTION.DOCUMENT_MANAGEMENT));
  }, [dispatch]);

  return (
    <div className="swim-wrapper h-100">
      {header && (
        <div className="DocumentManagementPageContainer__Header">{header}</div>
      )}
      <div
        className={`grid-layout gl-2 no-gap-tb swimlanes msa-medical-${layout}`}
      >
        {children}
        {footer && (
          <div className="DocumentManagementPageContainer__Footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentManagementPageContainer;
